import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import UserScreen from '../screen'
import UserGoalModal from '../../goals/edit-modal'

const UsersRoutes = () => {
    return (
        <React.Fragment>
            <Route exact path={CLIENT_ENDPOINTS.USER} component={UserScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.USER}${CLIENT_ENDPOINTS.USER_GOAL}`} component={UserGoalModal} />
        </React.Fragment>
    )
}

export default UsersRoutes